
// 插件路由
const bgroup = () => import(/* webpackChunkName: "addon" */ '~/addon/bgroup/pages/bgroup.vue')

const routes = [
	{ 
        path: '/bgroup', 
        component: bgroup 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/bgroup/router/index.js